import React from 'react';

function About() {
  return (
    <section id="about">
      <div className="container">
        <h2>'맑은뷰연구소'는?</h2>
        <div className="about-content">
          <div className="about-text">
            <p>맑은뷰연구소는 <strong>체계적인 시스템과 전문 기술력</strong>을 바탕으로 최상의 솔루션을 제공하는 윈도우 클리닝 및 건물 종합 관리 기업입니다.</p>
            <p>단순한 청소를 넘어 공간의 가치를 높이고, 고객님께 맑고 투명한 전망을 선사하기 위해 끊임없이 연구합니다. 풍부한 현장 경험과 검증된 노하우로 고객님의 자산을 소중히 관리합니다.</p>
            <p>친환경 케어 시스템과 전문 장비를 도입하여 안전하고 완벽한 결과물을 약속드립니다. 고객의 신뢰를 최우선 가치로 삼아, 쾌적하고 품격 있는 환경을 만들어가겠습니다.</p>
          </div>
          <div className="about-image">
            {/* Replace src with a real image URL from Pixabay or your assets */}
            <img src="img/about_team.png" alt="맑은뷰연구소 팀" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;